import { render, staticRenderFns } from "./API.vue?vue&type=template&id=55656c6f&scoped=true"
import script from "./API.vue?vue&type=script&lang=js"
export * from "./API.vue?vue&type=script&lang=js"
import style0 from "./API.vue?vue&type=style&index=0&id=55656c6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55656c6f",
  null
  
)

export default component.exports